import { setSpecificMessage, partialCheck } from "valibot";
setSpecificMessage(
  partialCheck,
  (issue) => `Valeur invalide: reçu ${issue.received}`,
  "fr"
);